angular.module('natura').provider("pggStyleProvider", [function () {
  var defaults = {
    blue: "rgba(51, 122, 183, 1)",
    white: "rgba(255, 255, 255, 1)",
    whiteTransparent: "rgba(255, 255, 255, 0.75)",
    red: "rgba(255, 0, 0, 1)",
    green: "rgba(0, 153, 0, 1)",
    width: 2
  };
  var config = {
    font: "BrandonText-Medium"
  };
  this.$get = [function (pggcaleProvider) {
    /**
     * GETTERS AND SETTERS
     */

    /***************************************************************************
     * FUNCTIONS
     **************************************************************************/

    var _createTextStyle = function (obj) {
      return new ol.style.Text({
        textAlign: "center",
        textBaseline: "middle",
        text: obj.text,
        font: "normal 14px Verdana",
        fill: new ol.style.Fill({
          color: obj.color
        }),
        offsetX: 0,
        offsetY: 0,
        rotation: 0,
        stroke: new ol.style.Stroke({
          color: obj.outlineColor,
          width: 3
        }),
      });
    };

    var _stringDivider = function (str, width, spaceReplacer) {
      if (str.length > width) {
        var p = width;
        while (p > 0 && (str[p] != ' ' && str[p] != '-')) {
          p--;
        }
        if (p > 0) {
          var left;
          if (str.substring(p, p + 1) == '-') {
            left = str.substring(0, p + 1);
          } else {
            left = str.substring(0, p);
          }
          var right = str.substring(p + 1);
          return left + spaceReplacer + _stringDivider(right, width, spaceReplacer);
        }
      }
      return str;
    };

    var _getObjName = function (obj) {
      var text = obj.feature.getProperties().name;
      if (typeof text == "undefined" || text === null || text.length === 0) {
        return "";
      } else {
        text = _stringDivider(text, 16, '\n');
        return text;
      }
    };

    var _createStyleFromDefaults = function (obj) {
      var style = null;
      switch (obj.style) {
        case "default":
          style = [new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(93, 119, 177, 0.3)"
            }),
            stroke: new ol.style.Stroke({
              color: defaults.whiteTransparent,
              width: defaults.width + 3
            })
          }), new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: defaults.blue,
              width: defaults.width
            }),
            text: _createTextStyle({
              color: defaults.blue,
              outlineColor: defaults.white,
              text: _getObjName(obj)
            })
          })];

          break;
        case "select":
          style = [new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.5)"
            }),
            stroke: new ol.style.Stroke({
              color: defaults.whiteTransparent,
              width: defaults.width + 3
            })
          }), new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: defaults.green,
              width: defaults.width
            }),
            text: _createTextStyle({
              color: defaults.green,
              outlineColor: defaults.white,
              text: _getObjName(obj)
            })
          })];
          break;
        case "hover":
          style = [new ol.style.Style({
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 0, 0.5)'
            }),
            stroke: new ol.style.Stroke({
              color: '#666600',
              width: 2
            }),
            image: new ol.style.Circle({
              fill: new ol.style.Fill({
                color: 'rgba(255, 255, 0, 0.7)'
              }),
              stroke: new ol.style.Stroke({
                width: 1,
                color: 'rgba(255, 255, 0, 0.9)'
              }),
              radius: 7
            })
          })];
          break;
        case "error":
          style = [new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 0, 0, 0.5)"
            }),
            stroke: new ol.style.Stroke({
              color: defaults.whiteTransparent,
              width: defaults.width + 3
            })
          }), new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: defaults.red,
              width: defaults.width
            }),
            text: _createTextStyle({
              color: defaults.red,
              outlineColor: defaults.white,
              text: _getObjName(obj)
            })
          })];
          break;
        case "errorSelected":
          style = [new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.5)"
            }),
            stroke: new ol.style.Stroke({
              color: defaults.whiteTransparent,
              width: defaults.width + 3
            })
          }), new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: defaults.red,
              width: defaults.width
            }),
            text: _createTextStyle({
              color: defaults.red,
              outlineColor: defaults.white,
              text: _getObjName(obj)
            })
          })];
          break;
        case "hole":
          style = [new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(0, 0, 0, 0.8)',
              lineDash: [10, 10],
              width: 3
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0)'
            })
          }), new ol.style.Style({
            image: new ol.style.RegularShape({
              fill: new ol.style.Fill({
                color: 'rgba(255, 0, 0, 0.5)'
              }),
              stroke: new ol.style.Stroke({
                color: 'black',
                width: 1
              }),
              points: 4,
              radius: 6,
              angle: Math.PI / 4
            })
          })];
          break;
        default:
          break;
      }
      return style;
    };

    var _getDefaultStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "default",
        feature: feat
      });
      return style;
    };

    var _getSelectStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "select",
        feature: feat
      });
      return style;
    };

    var _getHoverStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "hover",
        feature: feat
      });
      return style;
    };

    var _getErrorStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "error",
        feature: feat
      });
      return style;
    };

    var _getErrorSelectedStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "errorSelected",
        feature: feat
      });
      return style;
    };

    var _getHoleStyleByFeature = function (feat) {
      var style = _createStyleFromDefaults({
        style: "hole",
        feature: feat
      });
      return style;
    };

    /**
     * RETURNS
     */
    return {
      getDefaultStyleByFeature: _getDefaultStyleByFeature,
      getSelectStyleByFeature: _getSelectStyleByFeature,
      getHoverStyleByFeature: _getHoverStyleByFeature,
      getErrorStyleByFeature: _getErrorStyleByFeature,
      getErrorSelectedStyleByFeature: _getErrorSelectedStyleByFeature,
      getHoleStyleByFeature: _getHoleStyleByFeature
    };

  }];
}]);

angular.module('natura').provider("pggJstsProvider", [function () {
  var config = {
    ol3Parser: new jsts.io.OL3Parser(),
    wktReader: new jsts.io.WKTReader(),
    wktWriter: new jsts.io.WKTWriter(),
    geojsonReader: new jsts.io.GeoJSONReader(),
    geojsonWriter: new jsts.io.GeoJSONWriter()
  };

  this.$get = function () {
    /**
     * GETTERS AND SETTERS
     */
    var _getConfig = function () {
      return config;
    };
    /**
     * FUNCTIONS
     */
    var _isValidGeom = function (feature) {
      var jstsGeom = config.ol3Parser.read(feature.getGeometry());
      return jstsGeom.isValid();
    };

    var _isPointInPoly = function (geom, pointcoords) {
      var geomA = config.ol3Parser.read(geom);
      var geomB = config.ol3Parser.read(new ol.geom.Point(pointcoords));
      return geomB.within(geomA);
    };

    var _isRingTouchesOrOverlapsOuter = function (innerFeature, outerFeature) {
      var geomInner = config.ol3Parser.read(innerFeature.getGeometry());
      var geomOuter = config.ol3Parser.read(outerFeature.getGeometry());
      if (geomInner.touches(geomOuter) || geomInner.overlaps(geomOuter)) {
        return true;
      } else {
        return false;
      }
    };

    var _getSinglePolygonFromMultipolygon = function (inputGeom) {
      var polygon = inputGeom.getPolygons()[0];
      return polygon;
    };

    var _featureCollectionMultiPolygon = function (geojson, properties) {
      // ha polygon, akkor át kell alakítani multipolygonná, mert csak azt eszi
      // meg a webservice
      if (geojson.type == "Polygon") {
        geojson.type = "MultiPolygon";
        // a koordinátákat is be kell tenni egy plusz tömbbe
        geojson.coordinates = [geojson.coordinates];
      }
      var template = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {},
          properties: {}
        }]
      };
      template.features[0].geometry = geojson;
      template.features[0].properties = properties;
      return template;
    };

    var _geojsonFromOLFeature = function (feature, properties) {
      var featGeom = feature.getGeometry();
      var geom = config.ol3Parser.read(featGeom);
      var geojson = config.geojsonWriter.write(geom);
      return _featureCollectionMultiPolygon(geojson, properties);
    };

    /**
     * RETURNS
     */
    return {
      getConfig: _getConfig,
      isValidGeom: _isValidGeom,
      isPointInPoly: _isPointInPoly,
      isRingTouchesOrOverlapsOuter: _isRingTouchesOrOverlapsOuter,
      getSinglePolygonFromMultipolygon: _getSinglePolygonFromMultipolygon,
      geojsonFromOLFeature: _geojsonFromOLFeature
    };
  };
}]);

angular.module('natura').provider("pggScaleProvider", [function () {
  var scales = [{
    res: 280,
    scale: 1000000
  }, {
      res: 140,
      scale: 500000
    }, {
      res: 55.99999999999999,
      scale: 200000
    }, {
      res: 27.999999999999996,
      scale: 100000
    }, {
      res: 13.999999999999998,
      scale: 50000
    }, {
      res: 6.999999999999999,
      scale: 25000
    }, {
      res: 2.8,
      scale: 10000
    }, {
      res: 1.4,
      scale: 5000
    }, {
      res: 0.5599999999999999,
      scale: 2000
    }, {
      res: 0.27999999999999997,
      scale: 1000
    }];
  this.$get = function () {
    /**
     * GETTERS AND SETTERS
     */
    var _getScales = function () {
      return scales;
    };
    var _setScales = function (scales) {
      scales = scales;
    };
    /**
     * FUNCTIONS
     */
    var _getResolutions = function () {
      var array = [];
      angular.forEach(scales, function (scale) {
        array.push(scale.res);
      });
      return array;
    };
    var _getScaleForResolution = function (resolution) {
      for (var i = 0; i < scales.length; i++) {
        if (scales[i].res == resolution) {
          return scales[i].scale;
        }
      }
    };
    var _getResolutionForScale = function (scale) {
      for (var i = 0; i < scales.length; i++) {
        if (scales[i].scale + ".0" == scale) {
          return scales[i].res;
        }
      }
    };
    /**
     * RETURNS
     */
    return {
      getScales: _getScales,
      setScales: _setScales,
      getResolutions: _getResolutions,
      getScaleForResolution: _getScaleForResolution,
      getResolutionForScale: _getResolutionForScale
    };
  };
}]);

angular.module('natura').provider("pggInteractionsProvider", [function () {
  var config = {
    defaultInteractions: ol.interaction.defaults({
      doubleClickZoom: true,
      dragRotate: true,
      dragPan: true,
      pinchRotate: true,
      pinchZoom: true,
      keyboardPan: true,
      keyboardZoom: true,
      mouseWheelZoom: true,
      dragZoom: true
    }),
    addedInteractions: []
  };

  this.$get = ["pggFeatureinfoProvider", "pggEditProvider", function (pggFeatureinfoProvider, pggEditProvider) {
    /**
     * GETTERS AND SETTERS
     */
    var _getConfig = function () {
      return config;
    };
    var _getDefaultInteractions = function () {
      return config.defaultInteractions;
    };

    /**
     * Sets a default interaction to true or false
     *
     * @param interaction:
     *          e.g. ol.interaction.DoubleClickZoom
     * @param active:
     *          true or false
     */
    var _setDefaultInteraction = function (interactionClass, active) {
      config.defaultInteractions.getArray().forEach(function (a) {
        if (a instanceof interactionClass) {
          a.setActive(active);
        }
      });
    };

    var _getAddedInteractions = function () {
      return config.addedInteractions;
    };

    var _addInteraction = function (interaction) {
      config.addedInteractions.push(interaction);
      // TODO
    };

    var _removeInteraction = function (interaction) {
      for (var i = 0; i < config.addedInteractions.length; i++) {
        if (config.addedInteractions[i] == interaction) {
          // TODO
        }
      }
    };

    var _activateInteraction = function (interaction) {
      angular.forEach(config.addedInteractions, function (ia) {
        if (ia == interaction) {
          ia.setActive(true);
        } else {
          ia.setActive(false);
        }
      });
    };

    var _deactivateInteraction = function (interaction) {
      angular.forEach(config.addedInteractions, function (ia) {
        if (ia == interaction) {
          ia.setActive(false);
        }
      });
    };

    var _deactivateAll = function () {
      angular.forEach(config.addedInteractions, function (ia) {
        ia.setActive(false);
      });
      // pucolja ki a kijelölt elemeket
      if (pggEditProvider.getScope() !== null && pggEditProvider.getScope().hasOwnProperty("selectedElements")) {
        angular.forEach(pggEditProvider.getScope().selectedElements, function (element) {
          pggEditProvider.cancel(element.feature, false, false);
        });
        pggEditProvider.getScope().selectedElements = [];
      }
      // a featureinfo lekérdezést külön kell kezelni, mert az nem
      // ol.interaction
      pggFeatureinfoProvider.resetClick();
    };

    /**
     * RETURNS
     */
    return {
      getConfig: _getConfig,
      getDefaultInteractions: _getDefaultInteractions,
      setDefaultInteraction: _setDefaultInteraction,
      getAddedInteractions: _getAddedInteractions,
      addInteraction: _addInteraction,
      removeInteraction: _removeInteraction,
      activateInteraction: _activateInteraction,
      deactivateInteraction: _deactivateInteraction,
      deactivateAll: _deactivateAll
    };
  }];
}]);
